// extracted by mini-css-extract-plugin
module.exports = {"topright":"bancosDePreguntas_topright_1Pmd9","titulo":"bancosDePreguntas_titulo_x7mTZ"};